export default "__VITE_ASSET__BCsIQ$Dv__"